import '@assets/styles/pages/architect-details.scss';
import { ReactElement, useEffect } from 'react';
import { useFormik } from 'formik';
import { AccordianDetailList } from '@components/endUserDetails/components/moreDetailsForm/accordianDetailList';
import { defaultArchitectDetailFormInitialValues, defaultAccordianDetails } from '.';
import { getArchitectDetails } from '@helper/utils';
import { useMoreDetailsQuery } from '@services/hooks/enduser-details/useMoreDetailQuery';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { useEndUserStore } from '@store/enduser';
import { useStoreFormikFormValue } from '@store/setFormikFormValueStore';

export const ArchitectDetails = (): ReactElement => {
	const { isFormEdit, formId } = useEndUserStore();
	const {
		data: getMoreDetailFormData,
		isFetching: isMoreDetailFetching,
		error,
	} = useMoreDetailsQuery(formId, isFormEdit);
	const { storedFormikValues } = useStoreFormikFormValue();

	const formik = useFormik({
		initialValues: defaultArchitectDetailFormInitialValues,
		onSubmit: () => {},
	});

	useEffect(() => {
		if (storedFormikValues) {
			formik.setValues(storedFormikValues);
			return;
		}
		if (formId && getMoreDetailFormData && Object.keys(getMoreDetailFormData).length > 0) {
			const architectDetailsArr = getArchitectDetails(getMoreDetailFormData);
			const values = {
				...formik.values,
				architect_details: architectDetailsArr.length > 0 ? architectDetailsArr : defaultAccordianDetails,
			};
			formik.setValues(values);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getMoreDetailFormData, formId, isFormEdit, storedFormikValues]);

	return (
		<section className="architect-details-section">
			<Wrapper isLoaderVisible={isMoreDetailFetching} isError={error}>
				<div className="container">
					<form onSubmit={formik.handleSubmit}>
						<ul className="user-details-wrapper row">
							{formik.values.architect_details.map((architect, index) => (
								<AccordianDetailList
									key={architect.id}
									title="Architect and Interior Designer Details"
									accordianName="architect_details"
									accordianListIndex={index}
									formik={formik}
									data={architect}
									isEditing={true}
									isAddition
									isArchitectDetail={true}
								/>
							))}
						</ul>
					</form>
				</div>
			</Wrapper>
		</section>
	);
};
